import TradeMultistepFormRedirect from './trade-multistep-form-redirect';

export default TradeMultistepFormRedirect;
